import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/auth';
import { AutoCompleteBox, DateBox, FormButton } from "../commoncomponents/InputBox";
import { Table } from '../commoncomponents/Table';
//loder
import BlurLoader from "../Loder/BlurLoader";
//react toast 
import { toast } from 'react-toastify';
//common Data
import { API_SERVER } from '../../Utils';
//services
import { getCommonData } from '../../apiservices/CommonServices';
import { post } from '../../apiservices/service';
import { Token, dateFormate } from '../Common/Common';
import TextEditor from '../commoncomponents/TextEditor';

function PromotionLetter() {
    const inputrefs = useRef([]);
    const { user, sessionExpired } = useAuth();
    //token Data
    const TokenData = Token()

    //initial state
    const [recipe, setRecipe] = useState({
        branch: '',
        employee: '',
        PromotionDate: '',
    })

    const [loading, setLoading] = useState(false);
    const [branchAllData, setBranchAllData] = useState([])
    const [employeeAllData, setEmployeeAllData] = useState([])
    const [companyAllData, setCompanyAllData] = useState([])
    const [errors, setErrors] = useState({});
    const [textAreaFormate, setTextAreaFormate] = useState([]);
    const [result, setResult] = useState({});
    const [currentPageNo, setCurrentPageNo] = useState(1);

    //Get company Data for AutoComplete
    const GetCompanyData = (value) => {
        setCompanyAllData([])
        let temp = {
            Type: "GetCompany",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setCompanyAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setCompanyAllData(data)
                }
            }
        });
    }

    //Get branch Data for AutoComplete
    const GetBranchData = (value) => {
        setBranchAllData([])
        let temp = {
            Type: "GetBranch",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setBranchAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setBranchAllData(data)
                }
            }
        });
    }

    //Get employee Data for AutoComplete with call GetHistory API
    const GetEmployeeData = (value) => {
        setEmployeeAllData([])
        let temp = {
            Type: "GetEmployee",
            Prefix: value ? value : '',
            ContextKey: '',
            ContextKey2: ""
        }
        handleGetHistory(value)
        getCommonData({ ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    setLoading(false)
                    setEmployeeAllData([])
                } else {
                    setLoading(false)
                    let data = res && res.dataList && res.dataList.length > 0 ? res.dataList : []
                    setEmployeeAllData(data)
                }
            }
        });
    }

    //Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    // Handle Validation
    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "employee", msg: 'Please Enter Employee.' },
            { field: "PromotionDate", msg: 'Please Enter Promotion Date.' },
        ]

        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0 || recipe[item.field] === '') {

                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });
        return isValid;
    }

    // Get History Data for table 
    const handleGetHistory = (emp, CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        setLoading(true)
        let temp = {
            PageIndex: PageIndex.toString(),
            SearchText: "",
            StartValue: "1",
            SearchFieldValue: "",
            Type: "s",
            employee: emp ? emp : '',
        }
        post(`${API_SERVER}api/Print/GetPromotionLetterHistory`, { ...TokenData, ...temp, }, (res) => {
            if (res && res.Status) {
                if (res.Status === "ERROR") {
                    setLoading(false)
                    setResult({ ...res })
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    setResult({ ...res })
                }
                setLoading(false);
            }
            setLoading(false);
        });
    }

    // Handle change for table Pagination
    const handleChange1 = (event, value) => {
        handleGetHistory(recipe.employee, value);
    };

    // Handle Print and Insert  Formate
    const handlePrint = () => {
        if (Validate()) {
            setLoading(true)
            post(`${API_SERVER}api/Print/InsertPromotionLetter`, { ...TokenData, ...recipe, PromotionLetterFormat: textAreaFormate }, (res) => {
                if (res && res.status) {
                    if (res.status === "ERROR") {
                        toast.error(res.message)
                        setLoading(false)
                        inputrefs.current[res.focus].focus();
                        setLoading(false)
                    } else if (res.Status === "EXPIRED") {
                        toast.error(res.Message)
                        sessionExpired()
                    } else if (res.Status === "UNAUTHORIZED") {
                        toast.error(res.Message);
                        setLoading(false);
                    } else {
                        setLoading(false)
                        let base64PDF = res && res.promotionLetterFormat
                       // window.open(`/PdfView/#data:application/pdf;base64,${base64PDF}`, '_blank')
                        setTimeout(handleGetHistory(recipe.employee), 1000)
                        const byteCharacters = atob(base64PDF);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: 'application/pdf' });
                        const blobURL = URL.createObjectURL(blob);
                        setLoading(false)
                        const pdfWindow = window.open();
                        if (pdfWindow) {
                            pdfWindow.location.href = blobURL;
                        } else {
                            alert("Popup blocked! Please allow popups for this website.");
                        }
                    }
                    setLoading(false);
                }
                setLoading(false);
            });
        }
    }

    // Handle Print PDF Form Table
    const PrintPDFFromTable = (ID) => {
        post(`${API_SERVER}api/Print/PrintPromotionLetter`, { ...TokenData, PromotionLetterID: ID, employeeCode: recipe.employee }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                    inputrefs.current[res.focus].focus();
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)

                    let base64PDF = res && res.promotionLetterFormat
                    // window.open(`/PdfView/#data:application/pdf;base64,${base64PDF}`, '_blank')
                    const byteCharacters = atob(base64PDF);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const blobURL = URL.createObjectURL(blob);
                    setLoading(false)
                    const pdfWindow = window.open();
                    if (pdfWindow) {
                        pdfWindow.location.href = blobURL;
                    } else {
                        alert("Popup blocked! Please allow popups for this website.");
                    }
                }
            }
        });
    }

    //Handle Get Promotion Letter Formate
    const GetLetterFormatPreview = () => {
        let temp = {
            formatTypeName: "Promotion Letter",
            employeeCode: recipe.employee,
            TextDate: recipe.PromotionDate
        }
        setLoading(true)
        post(`${API_SERVER}api/Print/PreviewAppointmentLetter`, { ...TokenData, ...temp }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    setTextAreaFormate(res.appointmentLetterFormat)
                    setRecipe({ ...recipe, PromotionLetterFormat: res.appointmentLetterFormat })
                }
            }
        });
    }

    //Reset Handler
    const handleClear = () => {
        setRecipe(recipe => ({
            ...recipe,
            branch: '',
            employee: '',
            PromotionDate: '',
        }))
        setTextAreaFormate('')
        setErrors({})
        setResult({})
        inputrefs.current['txtBranch'].focus();
    }

    let CompanyData = []
    for (let i = 0; i < companyAllData.length; i++) {
        let mydata = companyAllData[i]?.values
        CompanyData.push(mydata)
    };

    let BranchData = []
    for (let i = 0; i < branchAllData.length; i++) {
        let mydata = branchAllData[i]?.values
        BranchData.push(mydata)
    };

    let EmployeeData = []
    for (let i = 0; i < employeeAllData.length; i++) {
        let mydata = employeeAllData[i]?.values
        EmployeeData.push(mydata)
    };

    useEffect(() => {
        inputrefs.current['txtBranch'].focus();
        document.title = 'Viva HRMS : Promotion Letter';
        GetBranchData();
        GetEmployeeData();
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">Promotion Letter</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="row">
                                <AutoCompleteBox
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtEmployee'].focus() };
                                    }}
                                    divclassname='col-md-6 '
                                    label='Branch'
                                    placeholder="Branch"
                                    maxLength='50'
                                    options={BranchData}
                                    id='txtBranch'
                                    key='txtBranch'
                                    inputValue={recipe.branch ? recipe.branch : ''}
                                    onInputChange={(event, newInputValue) => {
                                        GetBranchData(newInputValue)
                                        HandleChange('branch', newInputValue)
                                    }}
                                />
                                <AutoCompleteBox
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleGetHistory(e.target.value);
                                            inputrefs.current['txtPromotionDate'].focus();
                                        };
                                    }}
                                    divclassname='col-md-6 '
                                    label='Employee'
                                    placeholder="Employee"
                                    maxLength='50'
                                    options={EmployeeData}
                                    id='txtEmployee'
                                    key='txtEmployee'
                                    required={true}
                                    error={errors.employee}
                                    inputValue={recipe.employee ? recipe.employee : ''}
                                    onInputChange={(event, newInputValue) => {
                                        GetEmployeeData(newInputValue)
                                        HandleChange('employee', newInputValue)
                                    }}
                                />
                                <DateBox
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { handleGetHistory(recipe.employee) };
                                    }}
                                    divclassname='col-md-6 '
                                    id='txtPromotionDate'
                                    label='Promotion Date'
                                    placeholder="Promotion Date"
                                    selected={recipe.PromotionDate === '' ? '' : new Date(recipe.PromotionDate)}
                                    onChange={(e) => {
                                        HandleChange('PromotionDate', dateFormate(e))
                                    }}
                                    error={errors.PromotionDate}
                                    required
                                />
                                <FormButton
                                    saveButtonIcon='fa-search'
                                    SaveText='Preview'
                                    Export={false}
                                    reset={false}
                                    handleSubmit={GetLetterFormatPreview}
                                />
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-6'>

                            <Table
                                isOverFlow={true}
                                Filter={false}
                                Token={TokenData}
                                totalRecordText="History"
                                PageName='PromotionLetter'
                                handlePrintPdfData={PrintPDFFromTable}
                                tableData={result}
                                loading={loading}
                                currentPageNo={currentPageNo}
                                handleChange1={handleChange1}
                            />
                        </div>
                        <TextEditor
                            value={textAreaFormate}
                            setValue={(formate) => setTextAreaFormate(formate)}
                        />

                        <FormButton
                            save={false}
                            Export={false}
                            print={true}
                            handlePrint={handlePrint}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>

            {loading && < BlurLoader />}
        </>
    )
}

export default PromotionLetter
